import { LineItem, Order } from '../../types/orders';

export enum ActionTypes {
    Open = '[orders/authorize] OPEN',
    Dismiss = '[orders/authorize] DISMISS',
    ToggleItem = '[orders/authorize] TOGGLE_ITEM',
    ToggleAllItems = '[orders/authorize] TOGGLE_ALL_ITEMS',
    InvokeRequest = '[orders/authorize] START',
    SuccessResponse = '[orders/authorize] SUCCESS',
    ErrorResponse = '[orders/authorize] ERROR',
}

export interface Open {
    type: ActionTypes.Open;
    payload: {
        order: Order;
    };
}

export function openAuthorize(order: Order): Open {
    return {
        type: ActionTypes.Open,
        payload: {
            order,
        },
    };
}

export interface Dismiss {
    type: ActionTypes.Dismiss;
    payload: {};
}

export function dismissModal(): Dismiss {
    return {
        type: ActionTypes.Dismiss,
        payload: {},
    };
}

export interface Authorize {
    type: ActionTypes.InvokeRequest;
    payload: {
        accountId: string;
        order: Order;
        items: LineItem[];
    };
}

export function authorizeItems(accountId: string, order: Order, items: LineItem[]): Authorize {
    return {
        type: ActionTypes.InvokeRequest,
        payload: {
            accountId,
            order,
            items,
        },
    };
}

export interface AuthorizeSuccess {
    type: ActionTypes.SuccessResponse;
    meta: {
        cause: Authorize;
    };
}

export interface AuthorizeError {
    type: ActionTypes.ErrorResponse;
    payload: {
        code: string;
        message: string;
        errors: any;
    };
    meta: {
        cause: Authorize;
    };
}

export type AuthorizeResult = AuthorizeSuccess | AuthorizeError;

export type Actions = Open | Dismiss | Authorize | AuthorizeSuccess | AuthorizeError;
